//== Start add burger-menu ==//
const header = document.querySelector('.header')
const burgerBtn = document.querySelector('.header__burger')
const html = document.querySelector('html')
const menuItems = document.querySelectorAll('.header__menu a')
const links = document.querySelectorAll('.header__button')
const burgerMenu = document.querySelector('.header__main')
const close = document.querySelector('.header__main .close')
const dots = document.querySelector('.header__main .dots')

menuItems.forEach(item => {
  item.addEventListener('click', () => {
    header.classList.remove('open')
    burgerMenu.classList.remove('open')
    burgerBtn.classList.remove('open')
    changeHtmlOverflow('remove')
  })
})

links.forEach(link => {
  link.addEventListener('click', () => {
    burgerMenu.classList.remove('open')
    burgerBtn.classList.remove('open')
    header.classList.remove('open')
    changeHtmlOverflow('remove')
  })
})
close.addEventListener('click', () => {
  burgerMenu.classList.remove('open')
  burgerBtn.classList.remove('open')
  header.classList.remove('open')
  changeHtmlOverflow('remove')
})
dots.addEventListener('click', () => {
  burgerMenu.classList.remove('open')
  burgerBtn.classList.remove('open')
  header.classList.remove('open')
  changeHtmlOverflow('remove')
})


burgerBtn.addEventListener('click', () => {
  burgerMenu.classList.toggle('open')
  burgerBtn.classList.toggle('open')
  header.classList.toggle('open')

  if (burgerMenu.classList.contains('open')) {
    changeHtmlOverflow('add')
  } else {
    changeHtmlOverflow('remove')
  }
})
//== End add burger-menu ==//


const changeHtmlOverflow = (action) => {
  if (action === 'add') {
    html.style.overflow = 'hidden'
  }
  if (action === 'remove') {
    html.style.overflow = 'inherit'
  }
}

let lastScrollY = window.scrollY;
window.addEventListener('scroll', function () { const currentScrollY = window.scrollY; const scrollingDown = currentScrollY > lastScrollY; const scrollingUp = currentScrollY < lastScrollY; const nearTop = currentScrollY <= 50; if (nearTop) { header.classList.remove('hide', 'visible'); } else if (scrollingDown) { header.classList.add('hide'); header.classList.remove('visible'); } else if (scrollingUp) { header.classList.remove('hide'); header.classList.add('visible'); } lastScrollY = currentScrollY; });

//==  Add hover ==//

const getBtnAnimation = (btns) => {
  btns.forEach(btn => {

    btn.dataset.content = btn.innerHTML;

    btn.innerHTML = `
      <span class="label-up">${btn.dataset.content}</span>
      <span class="label-up">${btn.dataset.content}</span>
    `;
  });
};

const btns = document.querySelectorAll('.anim-btn p, .anim-btn span.contact-btn')
const headerButton = document.querySelectorAll('.header__button')
const menuBtns = document.querySelectorAll('.header__menu li a')
const contactBtns = document.querySelectorAll('.contact__right')
getBtnAnimation(menuBtns)
getBtnAnimation(headerButton)
getBtnAnimation(btns)
getBtnAnimation(contactBtns)

//==  End hover ==//



if (document.querySelector('.footer__scroll-top')) {
  document.querySelector('.footer__scroll-top').addEventListener('click', () => {
    console.log('test');

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}